import ILLAStorage from "@illa-public/illa-storage"

export const ILLACloudStorage = new ILLAStorage("ILLACloud@0.0.0", 5)
